import script from "./mutitabs.vue?vue&type=script&setup=true&lang=js"
export * from "./mutitabs.vue?vue&type=script&setup=true&lang=js"

import "./mutitabs.vue?vue&type=style&index=0&id=d09b5110&lang=css"

const __exports__ = script;

export default __exports__